<div class="light-blue-border flex flex-column dark-blue overflow-hidden main-container">
  <div class="preview-text-container flex justify-content-center">
    <span class="fw-bold p-2">Preview</span>
  </div>
  <div class="flex-grow-1 p-4 fw-normal" [innerHTML]="text">

  </div>
</div>
